import Loadable from 'react-loadable';

export const ResaleApiDoc = Loadable({
  loader: () => import('./ResaleApiDoc'),
  loading: () => null,
});


// WEBPACK FOOTER //
// ./src/containers/ResaleApiDoc/index.ts